module.exports = __webpack_public_path__ + "static/media/official-kikudoo-partner-pill.b8078c65.png";